module.exports = __webpack_public_path__ + "static/media/997501.e216b672.png";